export default __webpack_public_path__ + "static/media/aigeneric.55bef7bc.JPG";